import { createExporter } from "utils/createExporter";
import { candidateRequests } from "api/candidateApi";

export const CampaignExporter = campaignType =>
  createExporter(
    `candidate_campaigns_${campaignType}.xlsx`,
    [
      { key: "nameBg", label: "име на български език" },
      { key: "nameEn", label: "име на английски език" },
      { key: "registrationStart", label: "начало на регистрация" },
      { key: "registrationEnd", label: "край на регистрация" },
      { key: "type", label: "тип" },
    ],
    record => ({
      ...record,
      type: record.type?.name,
    }),
    [
      {
        source: "typeId",
        target: candidateRequests.getCampaignTypesSelect(),
        name: "type",
      },
    ],
  );
